module.exports = __webpack_public_path__ + "static/media/gc-athena-temple.eb7737fb.png";